import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./styling/footer.css";

import * as Sentry from "@sentry/react";
import  { getActivePdf } from '../dataSource/PDFSource';

import pinBlue from "../pages/assets/pin-blue.svg";
import insta from "../pages/assets/insta.svg";

import xCross from "./assets/x.svg";
import logo from "./assets/logoTrans.png";

import pdfMenuSatiata from "../pdf/latest_menu_satiata.pdf";
import pdfMenuPulcinos from "../pdf/latest_menu_pulcinos.pdf";

function Footer() {
  const [menuSelect, isMenuSelect] = useState(false);
  const [reserveSelect, isReserveSelect] = useState(false);
  const [isOpeningMenuPulcinos, setOpeningMenuPulcinos] = useState(false);
  const [isOpeningMenuSatiata, setOpeningMenuSatiata] = useState(false);

  let isFetchingPdf = false; // Prevent multiple simultaneous calls

   const handleOpenPdf = async (restaurant) => {
  
      const link = document.createElement("a");
      link.href = "";
      link.target = "_blank";
      document.body.appendChild(link);
  
      if (isFetchingPdf) {
        console.log("Already fetching the PDF. Exiting early.");
        return; // Prevent concurrent executions
      }
  
      setOpeningMenuPulcinos(true);
  
      console.log("Starting to fetch the PDF...");
      isFetchingPdf = true; // Lock the execution
  
      const maxRetries = 3; // Maximum number of retry attempts
      const retryDelay = 2000; // Delay between retries in milliseconds
  
      // Maakt elke waarde veilig loggbaar zonder enorme payload
      const describe = (value) => {
        if (typeof value === "string") return value.slice(0, 200);
        try {
          return JSON.stringify(value)?.slice(0, 200) ?? String(value);
        } catch {
          return Object.prototype.toString.call(value);
        }
      };
  
      const fetchWithRetry = async (retries) => {
  
    let lastError = null;
    let lastInvalidValue; // undefined = er kwam nooit een respons terug
  
    for (let attempt = 1; attempt <= retries; attempt++) {
      try {
        const menu = await getActivePdf(restaurant);
  
        if (
          menu &&
          typeof menu === "string" &&
          (menu.startsWith("http") || menu.startsWith("blob:"))
        ) {
          return menu;
        }
  
        lastInvalidValue = menu;
  
        console.log(`Invalid menu URL (Attempt ${attempt}):`, menu);
  
        Sentry.addBreadcrumb({
          category: "menu-pdf",
          level: "warning",
          message: `Poging ${attempt}: ongeldige menu-URL`,
          data: { received: describe(menu), receivedType: typeof menu },
        });
  
      } catch (error) {
        lastError = error;
  
        console.error(
          `Error during fetch (Attempt ${attempt}):`,
          error
        );
  
        Sentry.addBreadcrumb({
          category: "menu-pdf",
          level: "error",
          message: `Poging ${attempt}: ${error?.name ?? "Error"}`,
          data: { message: error?.message },
        });
      }
  
      if (attempt < retries) {
        await new Promise((resolve) =>
          setTimeout(resolve, retryDelay)
        );
      }
    }
  
    const shared = {
      tags: {
        feature: "menu-pdf",
        restaurant: String(restaurant),
        function: "fetchWithRetry",
        browserOnline: String(navigator.onLine),
      },
      extra: {
        attempts: retries,
        retryDelay,
        // page en userAgent stuurt Sentry zelf al mee
        lastValue:
          lastInvalidValue === undefined
            ? "(geen respons)"
            : describe(lastInvalidValue),
        lastValueType: typeof lastInvalidValue,
      },
    };
  
    if (lastError) {
      Sentry.captureException(lastError, {
        ...shared,
        tags: { ...shared.tags, reason: "fetch_threw" },
        fingerprint: ["menu-pdf", "fetch_threw"],
      });
    } else {
      Sentry.captureMessage(
        "Menu fetch failed: invalid response",
        {
          ...shared,
          level: "error",
          tags: { ...shared.tags, reason: "invalid_response" },
          fingerprint: ["menu-pdf", "invalid_response"],
        }
      );
    }
  
    return null;
  };
  
      try {
        const menu = await fetchWithRetry(maxRetries);
  
        if (menu) {
          console.log("Opening the menu:", menu);
  
          link.href = menu;
          link.download = `Menu_${restaurant}.pdf`;
          link.click();
  
            // Trigger the downlo
          console.log("Menu opened successfully. Exiting function.");
          return; // Exit the function immediately after opening the menu
        } else {
          // Geen tweede Sentry-event meer: fetchWithRetry heeft hierboven al
          // gerapporteerd, met meer detail dan hier beschikbaar is.
          console.log("Failed to fetch the menu after all retries.");
          alert("Er is iets mis gegaan met het openen van het Menu...");
        }
      } finally {
        console.log("Resetting the isFetchingPdf flag.");
        isFetchingPdf = false; // Unlock execution after completing
        setOpeningMenuPulcinos(false);
      }
    };
   
  

  return (
    <footer>
      {menuSelect && (
        <div id="menuSelectorBox">
          <div className="menuSelectorWrapper">
            <img onClick={() => isMenuSelect(false)} src={xCross} alt="x"></img>

            <h3>Welk menu wil je bekijken?</h3>

            <div className="menuSelectButtons">
              <button onClick={() => handleOpenPdf("pulcinos")}
                className="btn-pulci"
                disabled={isOpeningMenuPulcinos}>
                Menu Pulcinos
              </button>
              <button onClick={() => handleOpenPdf("satiata")}
                className="btn-satiata"
                disabled={isOpeningMenuSatiata}>
                Menu Satiata
              </button>
            </div>
          </div>
        </div>
      )}

      {reserveSelect && (
        <div id="menuSelectorBox">
          <div className="menuSelectorWrapper">
            <img onClick={() => isReserveSelect(false)} src={xCross} alt="x"></img>

            <h3>Waar wil je een tafel reserveren?</h3>

            <div className="menuSelectButtons">
               <a
                  href="https://restaurant-pulcinos.lurch.app/reservation/"
                  rel="noreferrer"
                  target="_blank"
                >
                  <button className="btn-pulci" >Pulcinos</button>
                </a>
                <a
                  href="https://pulcinos.lurch.app/reservation/"
                  rel="noreferrer"
                  target="_blank"
                >
                  <button className="btn-satiata" >Satiata</button>
                </a>
            </div>
          </div>
        </div>
      )}

      <div className="footerCol">
        <img className="footerLogo" src={logo} alt="Pulcinos logo"></img>

        <div className="footerHotLinks">
          <a onClick={() => isMenuSelect(true)}>
            <p>Menu</p>
          </a>
         <p className="yellow linkSpacer"> | </p>
          <Link to="/contact">
            <p>Contact</p>
          </Link>
        </div>

        <button className="checkout-btn" onClick={() => isReserveSelect(true)}>Reserveer een Tafel</button>
      </div>

      <p className="copyRight">© Pulcinos 2024 ⋅ Alle rechten voorbehouden.</p>
    </footer>
  );
}

export default Footer;
